import { render, staticRenderFns } from "./NxmbUpDateStudent.vue?vue&type=template&id=a004437a&scoped=true&"
import script from "./NxmbUpDateStudent.vue?vue&type=script&lang=js&"
export * from "./NxmbUpDateStudent.vue?vue&type=script&lang=js&"
import style0 from "./NxmbUpDateStudent.vue?vue&type=style&index=0&id=a004437a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a004437a",
  null
  
)

export default component.exports